// extracted by mini-css-extract-plugin
export default {"home":"Home_home__0iBhf","home__header":"Home_home__header__e9DTs","home__p":"Home_home__p__vWtmF"};